export const OFFERINGS = [
  {
    label: "Rooms",
    title: "Affordable Sanctuaries: Unveiling Our Rooms in Calangute",
    desc: "Step into a world of opulence and comfort at our guesthouse in Calangute, Goa. Whether you’re seeking luxury, convenience, or affordability, we’ve got you covered with our selection of deluxe rooms, spacious apartments, and cozy budget rooms.",
    img: "/images/rooms.png"
  },
  {
    label: "Hospitality",
    title: "True Goan Hospitality: Where Guests Become Family",
    desc: "At our guesthouse, we take pride in offering you an authentic taste of Goan hospitality. From the moment you step foot on our premises, you become a part of our extended family.",
    img: "/images/hospitality.png"
  },
  {
    label: "Leisure",
    title: "Unwind and Refresh: Poolside Bliss",
    desc: "Our exquisite pool facility offers crystal clear waters, comfortable lounging, and a poolside bar for ultimate leisure. Experience serenity day and night, with top-notch safety for your peace of mind. Your getaway deserves the best – welcome to our poolside haven",
    img: "/images/leisure.png"
  },
  {
    label: "Around us",
    title: "Embrace the Goa Pulse: Events Unveiled",
    desc: "Immerse yourself in the vibrant tapestry of Goa's cultural landscape with our guide to the hottest events happening around Calangute. From electrifying music festivals to bustling night markets, we bring you closer to the heart of Goa's vibrant scene.",
    img: "/images/around-us.png"
  },
]